import {Networking} from './utils/networking';

class AuthApi {
    postLogoutAction(formData) {
        return Networking.post(`/api/logout`, formData);
    }
    postChangePasswordAction(formData) {
        return Networking.post(`/api/change-password`, formData);
    }
    postLoginAction(formData) {
        return Networking.post(`/api/login`, formData);
    }
}

class UserPollingUnitApi {
    getDetailAction(formData) {
        return Networking.get(`/api/profile`, {params: formData});
    }
    postUpdateAction(formData) {
        return Networking.post(`/api/profile`, formData);
    }
    getListAction(id,formData) {
        return Networking.get(`/api/user-polling-unit/${id}`, {params: formData});
    }
    getDetailAction(id, formData) {
        return Networking.get(`/api/users/${id}`, {params: formData});
    }
    postFormAction(id, formData) {
        return Networking.post(`/api/user-polling-unit/${id}`, formData);
    }
    postDeleteAction(id, formData) {
        return Networking.post(`/api/users/delete/${id}`, formData);
    }

    postChangePasswordAction(formData) {
        return Networking.post(`/api/user/password-change`, formData);
    }
}


class UserApi {
    getDetailAction(formData) {
        return Networking.get(`/api/profile`, {params: formData});
    }
    postUpdateAction(formData) {
        return Networking.post(`/api/profile`, formData);
    }
    getListAction(formData) {
        return Networking.get(`/api/users`, {params: formData});
    }
    getDetailAction(id, formData) {
        return Networking.get(`/api/users/${id}`, {params: formData});
    }
    postFormAction(id, formData) {
        return Networking.post(`/api/users/${id}`, formData);
    }
    postDeleteAction(id, formData) {
        return Networking.post(`/api/users/delete/${id}`, formData);
    }

    postChangePasswordAction(formData) {
        return Networking.post(`/api/user/password-change`, formData);
    }
}
class PollingUnitApi {
    getDetailAction(formData) {
        return Networking.get(`/api/polling-unit`, {params: formData});
    }
    getListAction(formData) {
        return Networking.get(`/api/polling-units`, {params: formData});
    }
    getDetailAction(id, formData) {
        return Networking.get(`/api/polling-units/${id}`, {params: formData});
    }
    postFormAction(id, formData) {
        return Networking.post(`/api/polling-units/${id}`, formData);
    }
    postDeleteAction(id, formData) {
        return Networking.post(`/api/polling-units/delete/${id}`, formData);
    }
}
class ElectionApi {
    getListAction(formData) {
        return Networking.get(`/api/election/list`, {params: formData});
    }
    getDetailListAction(formData) {
        return Networking.get(`/api/elections/detail/list`, {params: formData});
    }
    postCreateAccreditedVotersAction(formData) {
        return Networking.post(`/api/accredited-voters/create`, formData);
    }
    postUpdateAccreditedVotersAction(formData) {
        return Networking.post(`/api/accredited-voters/update`, formData);
    }
    getListAction(formData) {
        return Networking.get(`/api/elections`, {params: formData});
    }
    getDetailAction(id, formData) {
        return Networking.get(`/api/elections/${id}`, {params: formData});
    }
    postFormAction(id, formData) {
        return Networking.post(`/api/elections/${id}`, formData);
    }
    postDeleteAction(id, formData) {
        return Networking.post(`/api/elections/delete/${id}`, formData);
    }
}
class ElectionResultApi {
    getListAction(formData) {
        return Networking.get(`/api/election/results`, {params: formData});
    }
    getDetailAction(formData) {
        return Networking.get(`/api/election-result`, {params: formData});
    }
    postCreateAction(formData) {
        return Networking.post(`/api/election-result/create`, formData);
    }
    postUpdateAction(formData) {
        return Networking.post(`/api/election-result/update`, formData);
    }
}
class PartyApi {
    getListAction(formData) {
        return Networking.get(`/api/election/parties`, {params: formData});
    }
    getListAction(formData) {
        return Networking.get(`/api/parties`, {params: formData});
    }
    getDetailAction(id, formData) {
        return Networking.get(`/api/parties/${id}`, {params: formData});
    }
    postFormAction(id, formData) {
        return Networking.post(`/api/parties/${id}`, formData);
    }
    postDeleteAction(id, formData) {
        return Networking.post(`/api/parties/delete/${id}`, formData);
    }
}
class CandidateApi {
    getListAction(formData) {
        return Networking.get(`/api/election/candidates`, {params: formData});
    }
    getListAction(formData) {
        return Networking.get(`/api/candidates`, {params: formData});
    }
    getDetailAction(id, formData) {
        return Networking.get(`/api/candidates/${id}`, {params: formData});
    }
    postFormAction(id, formData) {
        return Networking.post(`/api/candidates/${id}`, formData);
    }
    postDeleteAction(id, formData) {
        return Networking.post(`/api/candidates/delete/${id}`, formData);
    }
}
class ResetPasswordApi {
    postResetPasswordAction(formData) {
        return Networking.post(`/api/password/reset`, formData);
    }
}
class StateApi {
    getListAction(formData) {
        return Networking.get(`/api/states`, {params: formData});
    }
    getDetailAction(id, formData) {
        return Networking.get(`/api/states/${id}`, {params: formData});
    }
    postFormAction(id, formData) {
        return Networking.post(`/api/states/${id}`, formData);
    }
    postDeleteAction(id, formData) {
        return Networking.post(`/api/states/delete/${id}`, formData);
    }
}
class LocalGovernmentAreaApi {
    getListAction(formData) {
        return Networking.get(`/api/local-government-areas`, {params: formData});
    }
    getDetailAction(id, formData) {
        return Networking.get(`/api/local-government-areas/${id}`, {params: formData});
    }
    postFormAction(id, formData) {
        return Networking.post(`/api/local-government-areas/${id}`, formData);
    }
    postDeleteAction(id, formData) {
        return Networking.post(`/api/local-government-areas/delete/${id}`, formData);
    }
}
class WardApi {
    getListAction(formData) {
        return Networking.get(`/api/wards`, {params: formData});
    }
    getDetailAction(id, formData) {
        return Networking.get(`/api/wards/${id}`, {params: formData});
    }
    postFormAction(id, formData) {
        return Networking.post(`/api/wards/${id}`, formData);
    }
    postDeleteAction(id, formData) {
        return Networking.post(`/api/wards/delete/${id}`, formData);
    }
}
class SenatorialDistrictApi {
    getListAction(formData) {
        return Networking.get(`/api/senatorial-districts`, {params: formData});
    }
    getDetailAction(id, formData) {
        return Networking.get(`/api/senatorial-districts/${id}`, {params: formData});
    }
    postFormAction(id, formData) {
        return Networking.post(`/api/senatorial-districts/${id}`, formData);
    }
    postDeleteAction(id, formData) {
        return Networking.post(`/api/senatorial-districts/delete/${id}`, formData);
    }
}
class FederalConstituencyApi {
    getListAction(formData) {
        return Networking.get(`/api/federal-constituencies`, {params: formData});
    }
    getDetailAction(id, formData) {
        return Networking.get(`/api/federal-constituencies/${id}`, {params: formData});
    }
    postFormAction(id, formData) {
        return Networking.post(`/api/federal-constituencies/${id}`, formData);
    }
    postDeleteAction(id, formData) {
        return Networking.post(`/api/federal-constituencies/delete/${id}`, formData);
    }
}
class StateConstituencyApi {
    getListAction(formData) {
        return Networking.get(`/api/state-constituencies`, {params: formData});
    }
    getDetailAction(id, formData) {
        return Networking.get(`/api/state-constituencies/${id}`, {params: formData});
    }
    postFormAction(id, formData) {
        return Networking.post(`/api/state-constituencies/${id}`, formData);
    }
    postDeleteAction(id, formData) {
        return Networking.post(`/api/state-constituencies/delete/${id}`, formData);
    }
}
class ElectionTypeApi {
    getListAction(formData) {
        return Networking.get(`/api/election-types`, {params: formData});
    }
}
class ElectionCategoryApi {
    getListAction(formData) {
        return Networking.get(`/api/election-categories`, {params: formData});
    }
}
class PositionApi {
    getListAction(formData) {
        return Networking.get(`/api/positions`, {params: formData});
    }
}
class RoleApi {
    getListAction(formData) {
        return Networking.get(`/api/roles`, {params: formData});
    }
    getDetailAction(id, formData) {
        return Networking.get(`/api/roles/${id}`, {params: formData});
    }
    postFormAction(id, formData) {
        return Networking.post(`/api/roles/${id}`, formData);
    }
    postDeleteAction(id, formData) {
        return Networking.post(`/api/roles/delete/${id}`, formData);
    }
}
class PartyElectionPollingUnitApi {
    getListAction(formData) {
        return Networking.get(`/api/party/polling-units`, {params: formData});
    }
    getDetailAction(id, formData) {
        return Networking.get(`/api/party-election-polling-unit-detail/${id}`, {params: formData});
    }
}
class PartyElectionPollingUnitResultApi {
    getListAction(formData) {
        return Networking.get(`/api/party/polling-units`, {params: formData});
    }
    getDetailAction(id, formData) {
        return Networking.get(`/api/party-election-polling-unit-detail/${id}`, {params: formData});
    }
}
class SubscriptionApi {
    getListAction(formData) {
        return Networking.get(`/api/subscriptions`, {params: formData});
    }
    getDetailAction(id, formData) {
        return Networking.get(`/api/subscriptions/${id}`, {params: formData});
    }
    postFormAction(id, formData) {
        return Networking.post(`/api/subscriptions/${id}`, formData);
    }
    postDeleteAction(id, formData) {
        return Networking.post(`/api/subscriptions/delete/${id}`, formData);
    }
    postUpdateStatusAction(id, formData) {
        return Networking.post(`/api/subscriptions/update-status/${id}`, formData);
    }
}
class ElectionPositionApi {
    getListAction(formData) {
        return Networking.get(`/api/election-positions`, {params: formData});
    }
    getDetailAction(id, formData) {
        return Networking.get(`/api/election-positions/${id}`, {params: formData});
    }
    postFormAction(id, formData) {
        return Networking.post(`/api/election-positions/${id}`, formData);
    }
    postDeleteAction(id, formData) {
        return Networking.post(`/api/election-positions/delete/${id}`, formData);
    }
}
class ElectionPollingUnitApi {
    getListAction(formData) {
        return Networking.get(`/api/election-polling-units`, {params: formData});
    }
    getVoteListAction(formData) {
        return Networking.get(`/api/vote`, {params: formData});
    }
    getVoteListPollingAction(formData) {
        return Networking.get(`/api/vote-polling`, {params: formData});
    }

    getDetailAction(id, formData) {
        return Networking.get(`/api/election-polling-units/${id}`, {params: formData});
    }
    postFormAction(id, formData) {
        return Networking.post(`/api/election-polling-units/${id}`, formData);
    }
    postDeleteAction(id, formData) {
        return Networking.post(`/api/election-polling-units/delete/${id}`, formData);
    }
    postUpdateStatusAction(id, formData) {
        return Networking.post(`/api/election-polling-units/update-status/${id}`, formData);
    }
}
class VoteApi {
    getListAction(formData) {
        return Networking.get(`/api/vote`, {params: formData});
    }
    getDetailAction(id, formData) {
        return Networking.get(`/api/vote/${id}`, {params: formData});
    }
    postFormAction(id, formData) {
        return Networking.post(`/api/vote/${id}`, formData);
    }
    postDeleteAction(id, formData) {
        return Networking.post(`/api/vote/delete/${id}`, formData);
    }
    postUpdateStatusAction(id, formData) {
        return Networking.post(`/api/vote/update-status/${id}`, formData);
    }
    getVoteValue(formData) {
        return Networking.get(`/api/vote/value`, {params: formData});
    }
}
class ProfileApi {
    postUpdateAction(formData) {
        return Networking.post(`/api/user/profile`, formData);
    }
    getDetailAction(formData) {
        return Networking.get(`/api/user/profile`, {params: formData});
    }
}
class ElectionPollingUnitResultApi {
    getListAction(formData) {
        return Networking.get(`/api/election-results`, {params: formData});
    }
    getDetailAction(id, formData) {
        return Networking.get(`/api/election-results/${id}`, {params: formData});
    }
    postFormAction(id, formData) {
        return Networking.post(`/api/election-results/${id}`, formData);
    }
	getElectionResultExportAction(formData) {
        return Networking.get(`/api/election-results-export`, {params: formData});
    }
}
class ElectionPollingUnitAddResultApi {
    getListAction(formData) {
        return Networking.get(`/api/election-results`, {params: formData});
    }
	getElectionPartyListAction(formData) {
        return Networking.get(`/api/election-party-candidate-list`, {params: formData});
    }
    getDetailAction(id, formData) {
        return Networking.get(`/api/election-results/${id}`, {params: formData});
    }
    postFormAction(id, formData) {
        return Networking.post(`/api/election-results/${id}`, formData);
    }
}
class PrivilegeApi {
    getAction(formData) {
        return Networking.get(`/api/role/privileges`, {params: formData});
    }
    postFormAction(id, formData) {
        return Networking.post(`/api/role/privileges/${id}`, formData);
    }
}

class UploadApi {
    postFormAction(id, formData) {
        return Networking.post(`/api/upload/${id}`, formData);
    }
}

class CollationResultApi {
    getListAction(formData) {
        return Networking.get(`/api/collation-results`, {params: formData});
    }
    getDetailAction(id, formData) {
        return Networking.get(`/api/collation-results/${id}`, {params: formData});
    }
    postFormAction(id, formData, callback) {
        return Networking.post(`/api/collation-results/${id}`, formData, callback);
    }
}
class ImportApi {
    postFormAction(id, formData, callback) {
        return Networking.post(`/api/import-data/${id}`, formData, callback);
    }
    getDetailAction(id, formData) {
        return Networking.get(`/api/import-data/${id}`, {params: formData});
    }
}
class CheckListApi {
    getListAction(formData) {
        return Networking.get(`/api/check-lists`, {params: formData});
    }
    getDetailAction(id, formData) {
        return Networking.get(`/api/check-lists/${id}`, {params: formData});
    }
    postFormAction(id, formData) {
        return Networking.post(`/api/check-lists/${id}`, formData);
    }
    postDeleteAction(id, formData) {
        return Networking.post(`/api/check-lists/delete/${id}`, formData);
    }
    getMaxOrderNumberAction(formData) {
        return Networking.get(`/api/check-lists/max-order-no`, {params: formData});
    }
}
class DashboardApi {
    getElectionPollingUnitSubscriptionAction(formData){
        return Networking.get(`/api/dashboard/election-polling-unit-subscription`, {params: formData});
    }
    getRegionCountAction(formData){
        return Networking.get(`/api/dashboard/region-count`, {params: formData});
    }
    getSubscriptionAction(formData){
        return Networking.get(`/api/dashboard/subscription-count`, {params: formData});
    }
    getElectionSubscribedPollingUnitAction(formData){
        return Networking.get(`/api/dashboard/election-subscribed-polling-units`, {params: formData});
    }
}
class PartyCheckListApi {
    getListAction(formData) {
        return Networking.get(`/api/party-check-lists`, {params: formData});
    }
    getListActionReport(formData) {
        return Networking.get(`/api/party-check-lists-report`, {params: formData});
    }
    postUpdateStatusAction(id, formData) {
        return Networking.post(`/api/party-check-lists/update-status/${id}`, formData);
    }
}
class PartyIncidenceApi {
    getListAction(formData) {
        return Networking.get(`/api/party-incidence-list`, {params: formData});
    }
}

class ResultSummaryApi {
    getListAction(formData) {
        return Networking.get(`/api/result-summary`, {params: formData});
    }
}

class ResultSummaryNewApi {
    getListAction(formData) {
        return Networking.get(`/api/result-summary-new`, {params: formData});
    }
}


class Api {
    constructor() {
        this.auth = new AuthApi();
        this.user = new UserApi();
        this.pollingUnit = new PollingUnitApi();
        this.election = new ElectionApi();
        this.electionResult = new ElectionResultApi();
        this.party = new PartyApi();
        this.candidate = new CandidateApi();
        this.resetPassword = new ResetPasswordApi();
        this.state = new StateApi();
        this.localGovernmentArea = new LocalGovernmentAreaApi();
        this.ward = new WardApi();
        this.senatorialDistrict = new SenatorialDistrictApi();
        this.federalConstituency = new FederalConstituencyApi();
        this.stateConstituency = new StateConstituencyApi();
        this.electionType = new ElectionTypeApi();
        this.electionCategory = new ElectionCategoryApi();
        this.position = new PositionApi();
        this.role = new RoleApi();
        this.partyElectionPollingUnit = new PartyElectionPollingUnitApi();
        this.partyElectionPollingUnitResult = new PartyElectionPollingUnitResultApi();
        this.subscription = new SubscriptionApi();
        this.electionPosition = new ElectionPositionApi();
        this.electionPollingUnit = new ElectionPollingUnitApi();
        this.vote = new VoteApi();
        this.profile = new ProfileApi();
        this.electionPollingUnitResult = new ElectionPollingUnitResultApi();
        this.electionPollingUnitAddResult = new ElectionPollingUnitAddResultApi();
        this.userPollingUnit = new UserPollingUnitApi();
        this.privilege = new PrivilegeApi();
        this.upload = new UploadApi();
        this.collationResult = new CollationResultApi();
        this.import = new ImportApi();
        this.checkList = new CheckListApi();
        this.dashboard = new DashboardApi();
        this.partyCheckList = new PartyCheckListApi();
        this.partyIncidence = new PartyIncidenceApi();
        this.resultSummary = new ResultSummaryApi();
        this.resultSummaryNew = new ResultSummaryNewApi();
    }
}

export const api = new Api();



// WEBPACK FOOTER //
// ./resources/js/api.js